import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: column;
`

export const ProgressSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`

export const ProgressDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
`

export const ProgressLabel = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: #111827;
  flex: 1;
`

export const InProgressPill = styled.span`
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  color: #4338ca;
  background: #eef2ff;
`

export const ProgressBarTrack = styled.div`
  position: relative;
  height: 10px;
  border-radius: 999px;
  background: #e5e7eb;
  margin-bottom: 8px;
`

export const ProgressBarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: #22c55e;
  width: ${({ percent }) => percent}%;
  transition: width 0.3s ease;
`

export const ProgressTarget = styled.div`
  position: absolute;
  top: -4px;
  left: ${({ percent }) => percent}%;
  width: 2px;
  height: 18px;
  background: #6b7280;
`

export const ProgressTargetLabel = styled.div`
  text-align: right;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 32px;
`

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`

export const StatCard = styled.div`
  display: flex;
  flex-direction: column;
  ${({ $breakDown }) => ($breakDown ? 'gap: 4px;' : 'gap: 8px;')}
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px;
`

export const StatLabel = styled.div`
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 12px;
`

export const StatValue = styled.div`
  font-size: 40px;
  font-weight: 700;
  color: #111827;

  span {
    font-size: 30px;
    font-weight: 400;
    margin-left: 4px;
  }
`

// "Existing pressures / New pressures added / Total" breakdown card
export const BreakdownRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: ${({ $emphasis }) => ($emphasis ? '#111827' : '#444444')};
  font-weight: ${({ $emphasis }) => ($emphasis ? 700 : 400)};

  & + & {
    margin-top: 6px;
  }
`

export const SectionHeading = styled.div`
  padding-bottom: 5px;
  padding-top: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 20px;
  font-weight: 500;
  color: #111827;
`

export const ChartsRow = styled.div`
  display: grid;
  grid-template-columns: ${({ $columns }) => ($columns === 1 ? '1fr' : 'repeat(2, 1fr)')};
  gap: 16px;
`

export const EmptyCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 48px 24px;
  background: #ffffff;
  color: #6b7280;
  font-size: 16px;
  font-weight: 500;
`
